export default "__VITE_ASSET__DVuIuT3w__"